module.exports = __webpack_public_path__ + "static/media/dai-orbit.82c57999.svg";